<template>
    <div class="payment-methods" :id="id">
        <img
            v-if="klarna"
            src="@/assets/customizer_payment_klarna-min.png"
            width="70"
            height="40"
            alt="Klarna Logo"
        />
        <img
            v-if="visa"
            src="@/assets/customizer_payment_visa-min.png"
            width="70"
            height="40"
            alt="Visa Logo"
        />
        <img
            v-if="amex"
            src="@/assets/customizer_payment_amex-min.png"
            width="70"
            height="40"
            alt="AMEX Logo"
        />
        <img
            v-if="paypal"
            src="@/assets/customizer_payment_paypal-min.png"
            width="70"
            height="40"
            alt="PayPal Logo"
        />
        <img
            v-if="googlepay"
            src="@/assets/customizer_payment_googlepay-min.png"
            width="70"
            height="40"
            alt="Google Pay Logo"
        />
        <img
            v-if="sofort"
            src="@/assets/customizer_payment_sofort-min.png"
            width="70"
            height="40"
            alt="Sofort Logo"
        />
    </div>
</template>

<script>
export default {
    name: "PaymentMethods",
    props: {
        id: {
            type: String,
            default: "",
        },
        klarna: {
            type: Boolean,
            default: true,
        },
        visa: {
            type: Boolean,
            default: true,
        },
        amex: {
            type: Boolean,
            default: true,
        },
        paypal: {
            type: Boolean,
            default: true,
        },
        googlepay: {
            type: Boolean,
            default: true,
        },
        sofort: {
            type: Boolean,
            default: true,
        },
    },
};
</script>

<style lang="scss" scoped>
@use "@/assets/customizer.vars.scss" as *;

.payment-methods {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    column-gap: 40px;
    width: 100%;

    @media (max-width: $breakpoint-tablet) {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 32px;
        row-gap: 24px;
        max-width: 320px;
    }

    img {
        display: block;
    }
}
</style>
